import React from "react";
import * as ReactBootstrap from "react-bootstrap";
import { dollarUS } from "../../utilities/formatters";

// const StatFormatter = (data) => {
//     const Stat = data.toLowerCase()

//     const classList =
//         Stat === "passed"
//             ? "StatusPassed"
//             : "StatusInProgress"

//     return <div className={`Status ${classList}`}>{data}</div>
// }
const Icon1 = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8.25V12.75M9 5.25V12.75M6 9.75V12.75M9 15.75C6.1877 15.75 4.78155 15.75 3.79581 15.0338C3.47745 14.8025 3.19748 14.5225 2.96619 14.2042C2.25 13.2184 2.25 11.8123 2.25 9C2.25 6.1877 2.25 4.78155 2.96619 3.79581C3.19748 3.47745 3.47745 3.19748 3.79581 2.96619C4.78155 2.25 6.1877 2.25 9 2.25C11.8123 2.25 13.2184 2.25 14.2042 2.96619C14.5225 3.19748 14.8025 3.47745 15.0338 3.79581C15.75 4.78155 15.75 6.1877 15.75 9C15.75 11.8123 15.75 13.2184 15.0338 14.2042C14.8025 14.5225 14.5225 14.8025 14.2042 15.0338C13.2184 15.75 11.8123 15.75 9 15.75Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};
const Icon2 = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_14183)">
        <path
          d="M12.75 6.75L10.2231 9.57238C9.22181 10.6908 8.72115 11.25 8.0625 11.25C7.40385 11.25 6.90319 10.6908 5.90188 9.57238L5.25 8.84427M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_14183">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const icon3 = () => {
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_14192)">
      <path
        d="M4.02122 10.5182L4.71695 10.2381L4.02122 10.5182ZM6.87557 12.9365L6.57583 13.624L6.87557 12.9365ZM4.82587 11.7468L5.36068 11.221L4.82587 11.7468ZM13.9786 10.5182L13.2828 10.2381L13.9786 10.5182ZM11.1242 12.9365L11.424 13.624L11.1242 12.9365ZM13.1739 11.7468L13.7087 12.2726L13.1739 11.7468ZM14.0664 4.15271L13.3531 4.38447L14.0664 4.15271ZM11.6587 1.74506L11.4269 2.45835L11.6587 1.74506ZM3.93344 4.15271L4.64673 4.38447L3.93344 4.15271ZM6.34108 1.74506L6.57285 2.45835L6.34108 1.74506ZM1.7493 8.76695L1.29371 9.36272L1.30436 9.37086L1.31529 9.37862L1.7493 8.76695ZM16.2506 8.76695L16.6846 9.37862L16.6955 9.37086L16.7062 9.36272L16.2506 8.76695ZM8.2499 16.5615C8.2499 16.9757 8.58568 17.3115 8.9999 17.3115C9.41411 17.3115 9.7499 16.9757 9.7499 16.5615H8.2499ZM11.9999 17.3115C12.4141 17.3115 12.7499 16.9757 12.7499 16.5615C12.7499 16.1473 12.4141 15.8115 11.9999 15.8115V17.3115ZM5.9999 15.8115C5.58568 15.8115 5.2499 16.1473 5.2499 16.5615C5.2499 16.9757 5.58568 17.3115 5.9999 17.3115V15.8115ZM14.1646 4.56152L13.425 4.68612L14.1646 4.56152ZM14.4128 10.0709L14.8468 10.6826L14.4128 10.0709ZM3.59128 10.0739L3.15728 10.6856L3.59128 10.0739ZM13.4999 6.81152V7.78682H14.9999V6.81152H13.4999ZM4.4999 7.78682V6.81152H2.9999V7.78682H4.4999ZM10.8245 12.249C10.4336 12.4194 10.0607 12.564 9.73252 12.6648C9.39336 12.7691 9.14916 12.8115 8.9999 12.8115V14.3115C9.37129 14.3115 9.78331 14.2184 10.1732 14.0986C10.574 13.9755 11.0029 13.8075 11.424 13.624L10.8245 12.249ZM8.9999 12.8115C8.85063 12.8115 8.60644 12.7691 8.26727 12.6648C7.93909 12.564 7.56619 12.4194 7.17531 12.249L6.57583 13.624C6.99687 13.8075 7.4258 13.9755 7.82664 14.0986C8.21649 14.2184 8.6285 14.3115 8.9999 14.3115V12.8115ZM7.17531 12.249C6.12115 11.7894 5.75037 11.6174 5.36068 11.221L4.29107 12.2726C4.92008 12.9124 5.57619 13.1881 6.57583 13.624L7.17531 12.249ZM3.32548 10.7983C3.52633 11.2972 3.91402 11.8892 4.29107 12.2726L5.36068 11.221C5.12226 10.9785 4.84395 10.5536 4.71695 10.2381L3.32548 10.7983ZM11.424 13.624C12.4236 13.1881 13.0797 12.9124 13.7087 12.2726L12.6391 11.221C12.2494 11.6174 11.8786 11.7894 10.8245 12.249L11.424 13.624ZM13.2828 10.2381C13.1558 10.5536 12.8775 10.9785 12.6391 11.221L13.7087 12.2726C14.0858 11.8892 14.4735 11.2972 14.6743 10.7983L13.2828 10.2381ZM8.9999 2.31152C10.4542 2.31152 11.0035 2.32078 11.4269 2.45835L11.8905 1.03177C11.1841 0.80227 10.3375 0.811523 8.9999 0.811523V2.31152ZM14.7797 3.92095C14.3345 2.55098 13.2604 1.4769 11.8905 1.03177L11.4269 2.45835C12.3403 2.75511 13.0563 3.47116 13.3531 4.38447L14.7797 3.92095ZM8.9999 0.811523C7.66231 0.811523 6.81564 0.80227 6.10932 1.03177L6.57285 2.45835C6.99627 2.32078 7.54556 2.31152 8.9999 2.31152V0.811523ZM4.64673 4.38447C4.94348 3.47116 5.65953 2.75511 6.57285 2.45835L6.10932 1.03177C4.73935 1.4769 3.66527 2.55098 3.22014 3.92095L4.64673 4.38447ZM4.02528 9.46223L2.1833 8.15528L1.31529 9.37862L3.15728 10.6856L4.02528 9.46223ZM2.20489 8.17118C0.994261 7.24541 1.64895 5.31152 3.17297 5.31152V3.81152C0.214514 3.81152 -1.05636 7.5656 1.29371 9.36272L2.20489 8.17118ZM3.17297 5.31152H3.75V3.81152H3.17297V5.31152ZM14.8468 10.6826L16.6846 9.37862L15.8166 8.15528L13.9788 9.45925L14.8468 10.6826ZM16.7062 9.36272C19.0563 7.5656 17.7854 3.81152 14.8269 3.81152V5.31152C16.351 5.31152 17.0056 7.24541 15.795 8.17118L16.7062 9.36272ZM14.8269 3.81152H14.2499V5.31152H14.8269V3.81152ZM8.2499 13.5615V16.5615H9.7499V13.5615H8.2499ZM11.9999 15.8115H5.9999V17.3115H11.9999V15.8115ZM4.4999 6.81152C4.4999 5.70009 4.50251 5.11497 4.57476 4.68612L3.09561 4.43693C2.99728 5.02057 2.9999 5.76047 2.9999 6.81152H4.4999ZM4.57476 4.68612C4.59433 4.56999 4.61822 4.4722 4.64673 4.38447L3.22014 3.92095C3.16589 4.08792 3.12569 4.25836 3.09561 4.43693L4.57476 4.68612ZM3.75 5.31152H3.83518V3.81152H3.75V5.31152ZM2.9999 7.78682C2.9999 8.9408 2.99259 9.74501 3.21218 10.4754L4.64867 10.0436C4.5072 9.573 4.4999 9.02771 4.4999 7.78682H2.9999ZM3.21218 10.4754C3.24499 10.5846 3.28259 10.6917 3.32548 10.7983L4.71695 10.2381C4.69094 10.1735 4.66838 10.1091 4.64867 10.0436L3.21218 10.4754ZM13.4999 7.78682C13.4999 9.03306 13.4925 9.57785 13.3494 10.0493L14.7848 10.4849C15.0073 9.75151 14.9999 8.94554 14.9999 7.78682H13.4999ZM13.3494 10.0493C13.3301 10.1128 13.3081 10.1753 13.2828 10.2381L14.6743 10.7983C14.716 10.6948 14.7526 10.5908 14.7848 10.4849L13.3494 10.0493ZM14.9999 6.81152C14.9999 5.76047 15.0025 5.02057 14.9042 4.43693L13.425 4.68612C13.4973 5.11497 13.4999 5.70009 13.4999 6.81152H14.9999ZM14.9042 4.43693C14.8741 4.25835 14.8339 4.08792 14.7797 3.92095L13.3531 4.38447C13.3816 4.4722 13.4055 4.56999 13.425 4.68612L14.9042 4.43693ZM14.2499 3.81152H14.1646V5.31152H14.2499V3.81152ZM13.9788 9.45925C13.9117 9.50686 13.84 9.54756 13.7647 9.58073L14.3695 10.9534C14.5373 10.8795 14.6972 10.7887 14.8468 10.6826L13.9788 9.45925ZM3.15728 10.6856C3.31025 10.7941 3.47536 10.8845 3.64925 10.9548L4.21159 9.56418C4.14574 9.53755 4.08322 9.50334 4.02528 9.46223L3.15728 10.6856Z"
        fill="#FDE74C"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_14192">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0 0.0615234)"
        />
      </clipPath>
    </defs>
  </svg>;
};
const icon4 = () => {
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 11.2659L6.34525 9.03312C6.89845 7.90535 8.52438 7.96043 9 9.12305C9.47562 10.2857 11.1015 10.3407 11.6548 9.21298L12.75 6.98019M9 15.873C6.1877 15.873 4.78155 15.873 3.79581 15.1569C3.47745 14.9256 3.19748 14.6456 2.96619 14.3272C2.25 13.3415 2.25 11.9353 2.25 9.12305C2.25 6.31075 2.25 4.9046 2.96619 3.91885C3.19748 3.6005 3.47745 3.32053 3.79581 3.08923C4.78155 2.37305 6.1877 2.37305 9 2.37305C11.8123 2.37305 13.2184 2.37305 14.2042 3.08923C14.5225 3.32053 14.8025 3.6005 15.0338 3.91885C15.75 4.9046 15.75 6.31075 15.75 9.12305C15.75 11.9353 15.75 13.3415 15.0338 14.3272C14.8025 14.6456 14.5225 14.9256 14.2042 15.1569C13.2184 15.873 11.8123 15.873 9 15.873Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>;
};

const LongShortTable = ({ data }) => {
  const LongShort = [
    {
      Date: "No. of trades",
      icon: Icon1,
      Long: data && data.number_of_long_trade,
      Short: data && data.number_of_Short_trade,
    },
    {
      Date: "Result",
      icon: Icon2,
      Long: data && dollarUS(data.long_profit),
      Short: data && dollarUS(data.short_profit),
    },
    {
      Date: "Win rate",
      icon: icon3,
      Long: data && data.long_win_rate && Number(data.long_win_rate).toFixed(2),
      Short:
        data && data.short_win_rate && Number(data.short_win_rate).toFixed(2),
    },
    {
      Date: "Average profit",
      Long:
        data &&
        data.long_avg_profit &&
        dollarUS(Number(data.long_avg_profit).toFixed(2)),
      Short:
        data &&
        data.short_avg_profit &&
        dollarUS(Number(data.short_avg_profit).toFixed(2)),
    },
    {
      Date: "RRR",
      icon: icon4,
      Long: data && data.long_rrr && Number(data.long_rrr).toFixed(2),
      Short: data && data.short_rrr && Number(data.short_rrr).toFixed(2),
    },
  ];

  const renderLongShort = (longshort, index) => {
    return (
      <tr key={index}>
        <td>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <img src={longshort.icon} alt="" />
            {longshort.Date}
          </div>
        </td>
        <div className="stats_wrapper">
          <td>
            <div style={{ display: "flex", flexDirection: "column" , alignItems:"center" }}>
              <span style={{ color: "#0CCE6B" }}>Long</span> {longshort.Long}
            </div>
          </td>
          <td>
            <div style={{ display: "flex", flexDirection: "column" , alignItems:"center" }}>
              <span style={{ color: "#FD504F" }}>Short</span> {longshort.Short}
            </div>
          </td>
        </div>
      </tr>
    );
  };

  return (
    <div className="CommonTable">
      <ReactBootstrap.Table>
        <thead>
          {/* <tr>
            <th>Date</th>
            <th>Long</th>
            <th>Short</th>
          </tr> */}
        </thead>
        <tbody>{LongShort.map(renderLongShort)}</tbody>
      </ReactBootstrap.Table>
    </div>
  );
};

export default LongShortTable;
